module.exports = __webpack_public_path__ + "img/logo-light.28a22864.svg";